import React, { lazy } from 'react';

const CustomerInvoiceContainer = lazy(() => import('../../containers/CustomerInvoicesContainer'));
const UserInvoicesContainer = lazy(() => import('../../containers/userInvoicesContainer'));
const TwoStepMasterInvoicesContainer = lazy(() => import('../../containers/twoStepInvoices/twoStepMasterInvoicesContainer'));
const TwoStepInvoicesContainer = lazy(() => import('../../containers/twoStepInvoices/twoStepInvoicesContainer'));
const SubscriptionInvoicesContainer = lazy(() => import('../../containers/SubscriptionInvoicesContainer'));
const InvoiceSettingsPage = lazy(() => import('../../components/customerInvoices/Settings.jsx'));
const InvoicesContainer = lazy(() => import('../../containers/InvoicesContainer'));

export const INVOICES_ROUTES = [
  {
    path: '/invoices',
    component: <CustomerInvoiceContainer />,
    group: 'Invoices',
    reducer: ['customerInvoices', 'affiliateAccountSettings'],
  },
  {
    path: '/invoices/:id',
    component: <InvoicesContainer />,
    group: 'Invoices',
    reducer: ['invoices', 'affiliateAccountSettings']
  },
  {
    path: '/user-invoices',
    component: <UserInvoicesContainer />,
    group: 'Invoices',
    reducer: ['userInvoices', 'affiliateAccountSettings'],
    permission: 'settings'
  },
  {
    path: '/two-step-master-invoices',
    component: <TwoStepMasterInvoicesContainer />,
    group: 'Invoices',
    reducer: 'twoStepInvoices'
  },
  {
    path: '/two-step-invoices',
    component: <TwoStepInvoicesContainer />,
    group: 'Invoices',
    reducer: 'twoStepInvoices'
  },
  {
    path: '/subscription-invoices',
    component: <SubscriptionInvoicesContainer />,
    group: 'Invoices',
    reducer: 'subscriptionInvoices'
  },
  {
    path: '/invoices/settings',
    component: <InvoiceSettingsPage />,
    group: 'Invoices',
    reducer: []
  }
];
